import { SET_LEAD_VALUATIONS_REDUCER } from '../constants/get_lead_profile.constants';
import { GET_LEADS_ALL_VALUATIONS_REQUEST_FAILURE } from '../constants/cap.constants';
import { SET_LEADS_CUSTOMER_VALUATION_REQUEST, SET_LEADS_CUSTOMER_VALUATION_REQUEST_SUCCESS, SET_LEADS_CUSTOMER_VALUATION_REQUEST_FAILURE } from '../constants/set_customer_valuation.constants';
import { SET_LEAD_VALUATION_REQUEST } from '../../../Manage_retail/redux/constants/assign_lead.constants';

const initialState = {
    loading: false,
    valuations: [],
    customer_valuation: '',
    error: null,
};

export const Lead_valuations = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LEAD_VALUATIONS':
        return {
            ...state,
            ...action.payload,
        };
    case 'RESET_CUSTOMER_VALUATION':
        return {
            ...state,
            customer_valuation: '',
        };
    case 'RESET_ALL_VALUATIONS':
        return {
            ...state,
            valuations: [],
        };
    case SET_LEAD_VALUATIONS_REDUCER:
        return {
            ...state,
            loading: false,
            valuations: (action.payload && action.payload.length) ? action.payload.reverse() : [],
        };
    case SET_LEAD_VALUATION_REQUEST:
    case SET_LEADS_CUSTOMER_VALUATION_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case SET_LEADS_CUSTOMER_VALUATION_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            customer_valuation: action.customer_valuation,
            customer_valuation_date: action.customer_valuation_date,
            selling_reason: action.selling_reason,
            close_reason: action.close_reason,
        };
    case GET_LEADS_ALL_VALUATIONS_REQUEST_FAILURE:
    case SET_LEADS_CUSTOMER_VALUATION_REQUEST_FAILURE:
        return {
            ...state,
            valuations: [],
            selling_reason: '',
            customer_valuation: '',
            error: action.error,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_valuations.reducer.js